import en from "./en";

export default {
  en: en,
};
